<template>
<v-container fluid>
  <v-row no-gutters>
    <v-col cols="12">
      <v-card>
        <v-card-title>作業日報経費</v-card-title>
        <!-- 工事情報 -->
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="4">
              <v-text-field label="作業日" v-model="constructionDate" prepend-inner-icon="mdi-calendar-month" dense outlined readonly/>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field label="工事名" v-model="tabData.constructionName" prepend-inner-icon="mdi-message-settings-variant-outline" dense outlined readonly/>
            </v-col>
            <v-col cols="12" md="4">
              <v-select label="工種" v-model="tabData.constructionType" prepend-inner-icon="mdi-format-list-bulleted-triangle"
              :items="tabData.constructionTypeList" item-text="name" item-value="value" no-data-text="データがありません" dense outlined readonly>
              </v-select>
            </v-col>
            <v-col cols="12" md="4" v-if="!workAreaDivision">
              <v-select label="作業項目" v-model="tabData.workItem" prepend-inner-icon="mdi-format-list-bulleted-triangle"
              :items="tabData.workItemList" item-text="name" item-value="value" :disabled="tabData.constructionType == null" no-data-text="データがありません" dense outlined readonly>
              </v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <!-- 入力フォーム -->
        <v-form ref="tab_form" v-model="tabValid" @submit.prevent>
          <v-container fluid>
            <div v-if="expenseDivision">
              <v-toolbar color="accent" dark flat dense><v-toolbar-title>経費区分</v-toolbar-title></v-toolbar>
              <div v-for="(data, name) in expenseDataTable" :key="name">
                <v-row class="mt-5">
                  <v-col cols="12">
                    <v-data-table :headers="headers" :items="data" :items-per-page="itemPerPage" hide-default-footer :key="renderingKeyCount">
                      <template slot="top">
                        <v-toolbar color="grey" dark flat dense>
                          <v-toolbar-title>{{ name }}</v-toolbar-title>
                          <v-spacer/>
                        </v-toolbar>
                      </template>
                      <template v-slot:no-data>
                        データがありません。
                      </template>
                    </v-data-table>
                    <v-divider></v-divider>
                  </v-col>
                </v-row>
              </div>
            </div>
          </v-container>
        </v-form>
        <!-- アクション -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed color="grey lighten-1" :to="{ name: returnViewName, params: { worker_date: prmWorkerDate, user_id: prmUserId } }">戻る</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</v-container>
</template>

<script>
import { useAppInsights } from '@/plugins/application-insights';
import statusList from "@/helpers/const";
import WorkerDailyReportExpenseBulkApi from "@/api/worker-daily-report-expense-bulk-api";
export default {
  name: "WorkerDailyReportExpenseInfo",
  data: () => ({
    loading: false,
    returnViewName: "",
    // 画面引数
    prmRecordId: 0,
    prmUserId: null,
    prmWorkerDate: "",
    prmReferrer: "",
    // ------------------------
    // 共通
    // ------------------------
    renderingKeyCount: 0,
    // 作業日
    constructionDate: "",
    // 作業項目可否
    workAreaDivision: false,
    // 格納用
    tabData: {
      tabName: null,
      constructionId: null,
      constructionNumber: null,
      constructionName: null,
      siteName: null,
      constructionTypeList: null,
      constructionType: null,
      workArea: false,
      workItemList: null,
      workItem: null,
      startWorkerTime: null,
      endWorkerTime: null,
      workerBreakHourTime: null,
      workerBreakMinuteTime: null,
      startOverTime: null,
      endOverTime: null,
      overBreakHourTime: null,
      overBreakMinuteTime: null,
      workerContent: "",
      businessTrip: "",
      stay: false,
      move: 0,
      etc: false,
      remark: null,
      priceUpdated: "",
      expenseTableDataList: null,
      expenseTableData: null,
      expenseSelectBoxList: null,
      expenseSelectBox: null,
      workerTime: null,
      overTime: null
    },
    // バリデート
    tabValid: true,
    // データ表示数
    itemPerPage: 300,

    // ------------------------
    // 経費区分
    // ------------------------
    expenseDivisionData: [],
    expenseDivision: false,
    expenseDataTable: null,
    expenseSelectBox: null,
    headers: [
      { text: "費目名", value: "expense", sortable: false },
      { text: "規格等", value: "standard", sortable: false },
      { text: "実績 / 予算", value: "displayAchievement", sortable: false },
      { text: "単位", value: "displayUnit", sortable: false },
      { text: "取引先", value: "supplierName", sortable: false },
      { text: "アクション", value: "action", sortable: false }
    ]
  }),
  created() {
    this.initialize();
  },
  methods: {
    // ------------------------
    // 初期化処理
    // ------------------------
    initialize() {
      this.isLoading();
      // 画面引数をセット
      this.prmRecordId = this.$route.params.id;
      this.prmUserId = this.$route.params.user_id;
      this.prmWorkerDate = this.$route.params.worker_date;
      this.prmReferrer = this.$route.params.referrer;
      // パンくずリストの設定
      let breadcrumbs = [];
      if (this.prmReferrer == 'info') {
        // 作業日報閲覧画面からの遷移
        this.returnViewName = 'WorkerDailyReportInfo';
        const toView = {
          name: this.returnViewName,
          params: {
            worker_date: this.prmWorkerDate,
            user_id: this.prmUserId
          }
        };
        breadcrumbs = [
          { text: "ダッシュボード", disabled: false, href: "/dashboard" },
          { text: "作業日報一覧", disabled: false, href: "/report/daily/worker" },
          { text: "作業日報", disabled: false, href: null, to: toView },
          { text: "作業日報経費", disabled: true }
        ];
      }
      if (this.prmReferrer == 'approval') {
        // 作業日報確認(工事日報)からの遷移
        this.returnViewName = 'WorkerDailyReportApproval';
        const toView = {
          name: this.returnViewName,
          params: {
            worker_date: this.prmWorkerDate,
            user_id: this.prmUserId
          }
        };
        breadcrumbs = [
          { text: "ダッシュボード", disabled: false, href: "/dashboard" },
          { text: "工事日報一覧", disabled: false, href: "/report/daily/construction" },
          { text: "作業日報確認", disabled: false, href: "/report/daily/worker/comform" },
          { text: "作業日報", disabled: false, href: null, to: toView },
          { text: "作業日報経費", disabled: true }
        ];
      }
      if (breadcrumbs) {
        this.$route.meta.breadcrumbs = breadcrumbs;
        this.$emit('updatebc');
      }
      // 作業日報を取得
      this.constructionDate = this.prmWorkerDate;
      this.workerDailyReportExpenseBulkApi = new WorkerDailyReportExpenseBulkApi();
      const promise = this.workerDailyReportExpenseBulkApi.info(this.prmRecordId);
      promise.then((response) => {
        // 日報情報をセット
        this.tabData = response.data.body.worker_daily_report_info.report;
        // 集計費目情報
        const aggregate_list = response.data.body.aggregate_list;
        for (let agregateName in aggregate_list) {
          const agregate = response.data.body.aggregate_list[agregateName];
          this.expenseDivisionData[agregateName] = agregate;
        }
        // 経費情報をセット
        this.expenseDivision = false;
        if (this.tabData.constructionType != null) {
          const constructionTypeIndex = this.tabData.constructionType.value;
          this.tabData.expenseTableData = this.tabData.expenseTableDataList[constructionTypeIndex];
          for (let data of this.expenseDivisionData) {
            if (!(data.name in this.tabData.expenseTableData)) {
              this.tabData.expenseTableData[data.name] = [];
            }
          }
          this.expenseDataTable = this.tabData.expenseTableData;
          this.tabData.expenseSelectBox = this.tabData.expenseSelectBoxList[constructionTypeIndex];
          this.expenseSelectBox = this.tabData.expenseSelectBox;
          this.expenseDivision = true;
        }
        this.workAreaDivision = this.tabData.workArea;
      }).catch(error => {
        useAppInsights().trackException({exception: error});
        if (error.response) {
          if (error.response.data.status == statusList.status.authError) {
            this.$emit('logoutConform');
          } else if (error.response.data.status == statusList.status.entityError) {
            this.$emit("error", error.response.data.message);
            this.$router.push({ name: this.returnViewName, params: { worker_date: this.prmWorkerDate, user_id: this.prmUserId } });
          } else {
            this.$emit("error", error.response.data.message);
          }
        } else {
          this.$emit("error", "サーバーエラーが発生しました。");
        }
      }).finally(() => {
        this.isLoading();
      });
    },

    // ------------------------
    // その他処理
    // ------------------------
    // ローディング表示・非表示
    isLoading() {
      this.loading = !this.loading;
      this.$emit("loading", this.loading);
    }
  }
}
</script>
